<template>
  <div id="new-information">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="ショップニュース" backUrl="/" />
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="events"></footer-app>
      <!-- event information -->
      <NewsList :newsList="newsList" />
      <loader :loading="loading" />
      <!-- modal show required login -->
      <modal_login_required></modal_login_required>

      <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok"></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import Alert from "../components/Alert.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import { Tenant } from "../plugin/mixin.js";
import PopAlert from "../components/PopAlert.vue";
import loader from "../components/parts/loader.vue"
import { getLocalNewsListOfAllProvider, getServerNewsListOfAllProvider } from "../store/firestore.js";
import TopBar from "../components/TopBar.vue";
import NewsList from "../components/NewsList.vue";
export default Vue.extend({
  name: "News",
  components: {
    'footer-app': Footer,
    'modal_login_required': ModalLoginRequired,
    'alert': Alert,
    "loader": loader,
    PopAlert,
    TopBar,
    NewsList,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
      pageFade: false,
      newsList: [],
    }
  },
  async created() {
    this.loading = true;
    await this.getDataNews();
    this.loading = false;
  },

  methods: {
    async getDataNews() {
      const result = await getLocalNewsListOfAllProvider();
      if (result) {
        this.newsList = result.slice(0, this.newsSize);
      }
      setTimeout(async () => {
        const result = await getServerNewsListOfAllProvider();
        if (result) {
          this.newsList = result.slice(0, this.newsSize);
        }
      });
    },
  },
})
</script>
